import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  loading: true,
}

const UIBootstrapReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.START_INITIALIZE:
      return { ...state, loading: true }

    case Actions.FINISH_INITIALIZE:
      return { ...state, loading: false }

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

export default UIBootstrapReducer
